import {useMemo} from 'react';

import {FormSection} from '../../../../../../components/FormMaker/types';
import {ApplicantProfile} from '../../../types';

export const useSalarySection = (profile: ApplicantProfile): FormSection[] => {
  return useMemo<FormSection[]>(
    () => [
      {
        type: 'stacked',
        data: {
          sections: [
            {
              type: 'number',
              data: {type: 'number', name: 'minSalaryValue', initialValue: profile.minSalaryValue || 0, label: 'Min.'},
            },
            {
              type: 'number',
              data: {type: 'number', name: 'maxSalaryValue', initialValue: profile.maxSalaryValue || 0, label: 'Max.'},
            },
          ],
        },
      },
    ],
    [profile.maxSalaryValue, profile.minSalaryValue]
  );
};
